// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"dcc87167","750":"db2ffa8c","760":"a4289018","840":"12539aca","926":"a05635f3"}[chunkId] + ".chunk.js";
};